/**
 * Directory → Billing and the shared Credits ledger (also surfaced in Platform)
 * are not open to all org members.
 *
 * Access rules (Kyle, Nov 2026):
 * - Super Admin can always open Billing / the ledger.
 * - Anyone else only if a Super Admin has granted them billing permission.
 * - Do not treat Organization Owner, Account Admin, or billing_admin as implicit access.
 *
 * Grant storage: platform should expose `billingAccessGranted` (or equivalent) on
 * `/api/directory/me` and the Platform operator view. Until that flag is live,
 * only `isSuperAdmin` unlocks the page.
 */
export function canViewBilling(input: {
  isSuperAdmin: boolean;
  /** Explicit Super Admin grant for this person (org or platform scoped). */
  billingAccessGranted?: boolean | null;
}): boolean {
  if (input.isSuperAdmin) return true;
  return input.billingAccessGranted === true;
}

export const BILLING_ACCESS_DENIED_COPY =
  "Billing and the Credits ledger are limited to Super Admins, or people a Super Admin has granted billing access. Your account does not have that permission for this organization.";
